<template lang="pug">
#modelTree
  .title
    span 模型树
    i.el-icon-close(@click='closeAdd')
  .content
    el-tree.navTree(
      ref='tree',
      node-key="mgNodeId",
      :props='defaultProps',
      :load="loadNode"
      lazy
      v-slot="{ node, data }")
      .tree-node
        el-checkbox(
          :indeterminate="indeterminateMap[data.mgNodeId]"
          @click.native.capture.stop,
          :value="checkKeysList"
          :label='data.mgNodeId'
          @input="keysCheckChange($event,node)"
        )
          span
        .labelst(@click.stop="handleClick(data)" :title="data.label") {{data.label}}
  </template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
// import _ from "lodash";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      treeData: [],
      checkKeysList: [],
      indeterminateMap: {},
      nodeMap: {},
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    checked_arr() {
      return mongeApp.model.showElementIdlist;
    },
    hiddenElementIdList() {
      return mongeApp.model.hiddenElementIdList;
    }

  },
  // watch: {
  //   hiddenElementIdList(val) {
  //     _.throttle(function filterTags() {
  //       this.checkList();
  //     }, 1000, { trailing: true }).call(this);
  //   }
  // },
  mounted () {
    // if (this.modelReady) this.getTreeData();
    // mongeApiMlib.elementShowAll();// 默认全部显示
    this.checkKeysList = [];
  },
  methods: {
    isIndeterminate(node) {
      return this.checkKeysList.find(e => e.mgNodeId === node.data.mgNodeId).type === -1;
    },
    async loadNode(node, resolve) {
      const list = await mongeApiMlib.loadTreeData(node);
      for (const e of list) {
        const type = mongeApiMlib.elementIsHide(e.modelId, e.elementId);
        if (type === 0) {
          this.checkKeysList.push(e.mgNodeId);
        } else if (type === -1) {
          this.$set(this.indeterminateMap, e.mgNodeId, true);
        }
      }
      resolve(list);
    },
    keysCheckChange(val, node) {
      const idSet = new Set(val);
      const { data: { modelId, elementId, mgNodeId }} = node;
      const boolean = idSet.has(mgNodeId);
      this.$set(this.indeterminateMap, mgNodeId, false);
      if (boolean) {
        mongeApiMlib.elementIdShow(modelId, elementId);
      } else {
        mongeApiMlib.elementIdHide(modelId, elementId);
      }
      // 向下处理节点
      const clist = [...node.childNodes];
      for (const cnode of clist) {
        const cid = cnode.data.mgNodeId;
        boolean ? idSet.add(cid) : idSet.delete(cid);
        clist.push(...cnode.childNodes);
      }
      // 向上处理
      const plist = [node.parent];
      for (const pnode of plist) {
        const pid = pnode?.data?.mgNodeId;
        if (!pid) break;
        const childNodes = pnode.childNodes;
        const hasList = childNodes.filter((n) => idSet.has(n.data.mgNodeId));
        this.$set(this.indeterminateMap, pid, false);
        if (hasList.length === 0) {
          idSet.delete(pid);
        } else if (hasList.length === childNodes.length) {
          idSet.add(pid);
        } else {
          idSet.add(pid);
          this.$set(this.indeterminateMap, pid, true);
        }
        const ppnode = pnode.parent;
        if (ppnode) plist.push(ppnode);
      }
      this.checkKeysList = [...idSet];
    },
    async dealType(data, type) {
      if (type === 0) {
        await mongeApiMlib.elementIdHide(data.modelId, data.elementId);
        return 1;
      } else if (type === 1) {
        await mongeApiMlib.elementIdShow(data.modelId, data.elementId);
        return 0;
      } else if (type === -1) {
        await mongeApiMlib.elementIdShow(data.modelId, data.elementId);
        return 0;
      }
    },
    miniCom() {
      this.$emit("closeCom", "modelTree", true);
    },
    closeAdd() {
      this.$emit("closeCom", "modelTree", false);
    },
    handleClick(data) {
      mongeApiMlib.selectPick(data);
    }
  }
};
</script>
<style lang="scss" scoped>
.tree-node{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .labelst {
    margin-left: 5px;
    width: calc(100% - 25px);
  }
}

#modelTree{
  position: fixed;
  bottom: 0;
  left: 0;
  top: 44px;
  z-index: 4;
  width: 260px;
  height: calc(100% - 44px);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  .title{
    width: 100%;
    height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E8F1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    span{
      font-size: 17px;
      font-weight: 700;
    }
    i{
      font-size: 16px;
    }
  }
  .content{
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px 5px 0;
  }
}
</style>
